import React, { useEffect, useState } from 'react';
import { IoMdHeartEmpty } from 'react-icons/io';
import { BsBag, BsBagFill } from 'react-icons/bs';
import { useUserContext } from '../../context/user_context';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FaRegHeart, FaHeart } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useCartContext } from '../../context/cart_context';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
} from '@chakra-ui/react';
import { formatPrice } from '../../utils/helpers';
const ProductList = ({ data, id, userWishlistItems, userCartItems, checkCartStatus, checkWishlistStatus }) => {
  const [hovered, setHovered] = useState(false);
  const { currentUser } = useUserContext();
  const { handlecartButton, setMainColor } = useCartContext();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [wishlistButtonText, setWishlistButtonText] =
    useState('Add to wishlist');
  const [cartButton, setCartButton] = useState(<BsBag fill='#D3A143' />);
  const [wishlistButton, setWishlistButton] = useState(
    <FaRegHeart className='heart' fill='#D3A143' />
  );
  const [loading, setLoading] = useState(false);

   const checkCartButtonStatus = async () => {
     let isMounted = true;
     try {
       let userid = currentUser?.id;

       if (currentUser) {
         const response = await axios.get(
           `${process.env.REACT_APP_BACKEND_HOST}/api/user/addtocart/${userid}`
         );
         const array = response.data.data;

         const isPresent = array.some((order) => order.id == data.id);

         if (isPresent) {
           setCartButton(<BsBagFill fill='#D3A143' />);
         } else {
           setCartButton(<BsBag fill='#D3A143' />);
         }
       }
     } catch (e) {
       if (isMounted) {
         setLoading(false);
       }
     }
     return () => {
       isMounted = false;
     };
   };


  const handleWishlistButton = async (id) => {
    let userid = currentUser?.id;
    if (currentUser) {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_HOST}/api/user/wishlistitem/${userid}`
      );
      const array = response?.data?.data || [];

      let isPresent = array?.some((e)=>e.id==data.id);
      let options = { wishlistItem: Number(data.id) };
      if (!isPresent) {
        try {
          let res = await axios.put(
            `${process.env.REACT_APP_BACKEND_HOST}/api/user/wishlistitem/${userid}`,
            { id }
          );
          toast.success('Item added to wishlist');
          setWishlistButtonText('Remove from wishlist');
          setWishlistButton(
            <FaHeart className='heartSelected' fill='#D3A143' />
          );
        } catch (error) {
          console.error('Error adding item to wishlist:', error);
        }
      } else {
        try {
          const data = {
            wishlistItem: id,
          };
          const userid = currentUser?.id;
          const response = await axios.delete(
            `${process.env.REACT_APP_BACKEND_HOST}/api/user/wishlistitem/${userid}`,
            { data }
          );

          toast.success('Item removed from wishlist');
          setWishlistButtonText('Add to wishlist');
          setWishlistButton(<FaRegHeart className='heart' fill='#D3A143' />);
        } catch (error) {
          console.error('Error deleting item from wishlist:', error);
        }
      }
    } else {
      onOpen();
    }

  };


  const handleTouch = () => {
    setHovered(!hovered);
  };


  useEffect(() => {
    if (id) {
      const isPresentCart = userCartItems?.some((order) => order?.id == data.id);

      if (isPresentCart) {
        setCartButton(<BsBagFill fill='#D3A143' />);
      } else {
        setCartButton(<BsBag fill='#D3A143' />);
      }

      const isPresent = userWishlistItems?.some((e)=>e?.id==data.id);
      if (userWishlistItems !== null) {
        setWishlistButtonText(
          isPresent ? 'Remove from Wishlist' : 'Add to Wishlist'
        );
        setWishlistButton(
          isPresent ? (
            <FaHeart className='heartSelected' fill='#D3A143' />
          ) : (
            <FaRegHeart className='heart' fill='#D3A143' />
          )
        );
      } else {
        setWishlistButtonText('Add to Wishlist');
      }
    }
  }, [id]);
  const handleCartButtonClick = async () => {
    if (currentUser) {
      await handlecartButton(
        data.id,
        1,
        currentUser,
        data?.size,
        setCartButton,
        onOpen,
        data?.productCode,
        data?.bestOffers,
        data?.taxPrice,
        data?.weight,
        data?.discountPercentage,
        data?.price,
        data?.price,
        data?.quantity
      );
      checkCartButtonStatus();
    } else {
      onOpen();
    }
  };

  return (
    <div key={id} className='flex flex-col w-full bg-white rounded-lg'>
      <div className='m-auto 2xs:flex 2xs:flex-col sm:justify-between h-auto'>
        <Link to={`/collections/${data?.id}`} className='relative inline-block'>
          {data?.quantity < 1 && (
            <span className='absolute top-2 left-2 bg-red-600 text-white text-xs px-2 py-1 rounded-md z-10'>
              Out of Stock
            </span>
          )}

          <>
            <img
              src={data?.productImageUrl[0]}
              alt={data?.description}
              className='rounded-lg w-full h-auto object-contain aspect-square'
            />
            <p className='mt-2 text-sm text-gray-800'>{data?.name}</p>
          </>
        </Link>

        <div className='flex justify-between items-end mt-2 w-full mr-2'>
          <div className='flex flex-col gap-1 text-sm lg:text-sm'>
            <p className='font-medium text-black'>
              {formatPrice(data?.subPrice)}
            </p>
            {data?.discountPercentage > 0 && (
              <div className='flex flex-row items-center gap-2 text-xs xs:flex-row 2xs:flex-col 2xs:items-start 2xs:gap-0'>
                <p className='line-through text-gray-500 font-medium'>
                  {data?.discountPrice &&
                    formatPrice(
                      Number(data?.price) + Number(data?.discountPrice)
                    )}
                </p>
                <p className=' text-red-600'>
                  ({data?.discountPrice && formatPrice(data?.discountPrice)}{' '}
                  Off)
                </p>
              </div>
            )}
          </div>

          <div className='flex gap-1 text-lg text-gray-600'>
            <p
              className='cursor-pointer hover:text-red-500'
              onClick={() => handleWishlistButton(data?.id)}
            >
              {wishlistButton}
            </p>

            <p
              className='cursor-pointer hover:text-gray-800'
              onClick={handleCartButtonClick}
            >
              {cartButton}
            </p>
          </div>
        </div>
      </div>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Please Login</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <p>Please login to add items to your cart and wishlist.</p>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={onClose}>
              Close
            </Button>
            <Link to='/login'>
              <Button variant='ghost'>Login</Button>
            </Link>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default ProductList;
